export default __webpack_public_path__ + "static/media/bannervide4.6f1160a5.mp4";